import {BANK_TYPES} from '../../constants/typesMessages';
import {removeMask} from '../../utils/removeMask';

export const clearNumbers = (numbers) => {
  return removeMask(numbers);
};

export const validateBankBranch = (branch, bankBranch, bankEcObject) => {
  // Verificar se contém apenas números
  if (!/^\d+$/.test(branch)) {
    return {
      messages: [
        {
          text: bankBranch,
          type: BANK_TYPES.BANK_FLOW
        },
        {
          text: 'Por favor, digite apenas números para a agência bancária.',
          type: 'message-receive'
        }
      ],
      bank: bankEcObject,
      responseFlowChange: BANK_TYPES.BANK_BRANCH,
      responseTypeChange: BANK_TYPES.BANK_FLOW,
      completed: false,
      error: true
    };
  }

  if (branch.length < 4) {
    return {
      messages: [
        {
          text: bankBranch,
          type: BANK_TYPES.BANK_FLOW
        },
        {
          text: 'Por favor, verifique a agência digitada e tente novamente.',
          type: 'message-receive'
        }
      ],
      bank: bankEcObject,
      responseFlowChange: BANK_TYPES.BANK_BRANCH,
      responseTypeChange: BANK_TYPES.BANK_FLOW,
      completed: false,
      error: true
    };
  }

  return {error: false};
};

const validateMask = (mask) => {
  const maskLengthDefault = 14;
  if (mask) {
    mask = clearNumbers(mask);
    return mask.length;
  }
  return maskLengthDefault;
};

const getMessageBankAccountInvalid = (bankAccount, bankEcObject) => {
  return {
    messages: [
      {
        text: bankAccount,
        type: BANK_TYPES.BANK_FLOW
      },
      {
        text: 'Por favor, verifique a conta digitada e tente novamente.',
        type: 'message-receive'
      }
    ],
    bank: bankEcObject,
    responseFlowChange: BANK_TYPES.BANK_ACC,
    responseTypeChange: BANK_TYPES.BANK_FLOW,
    completed: false,
    error: true
  };
};

const accountIsNotPj = (bankAccount) => {
  const accountsAllows = ['003', '022', '023'];
  const typeAccount = bankAccount.slice(0, 3);
  return !accountsAllows.includes(typeAccount);
};

const accountIsNumber = (account) => {
  // Regex otimizada que evita backtracking excessivo
  // ^: início da string
  // -?: sinal negativo opcional no início
  // \d*: zero ou mais dígitos
  // (\.(\d+))?: ponto decimal seguido de um ou mais dígitos (tudo opcional)
  // $: fim da string
  const re = /^-?\d*(\.(\d+))?$/;
  return !re.test(account);
};

export const validateBankAccount = (account, bankAccount, bankEcObject) => {
  const maskLength = validateMask(bankEcObject.mask);
  const haveLetterFirst = accountIsNumber(account.slice(0, account.length - 2));

  if (account.length > maskLength || haveLetterFirst)
    return getMessageBankAccountInvalid(bankAccount, bankEcObject);

  return {error: false};
};
